import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";
import { getImpersonation, isImpersonating } from "./userMatrixStorage";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
    if (isImpersonating()) {
      const imp = getImpersonation();
      if (imp?.email) {
        h["X-PB-Impersonate-Email"] = String(imp.email).trim().toLowerCase();
      }
      if (imp?.userTypeId) {
        h["X-PB-Impersonate-User-Type-Id"] = String(imp.userTypeId).trim();
      }
    }
  } catch {
    /* ignore */
  }
  return h;
}

/** @returns {{ balance: number }} */
export async function fetchMarketplaceBalance() {
  const { data } = await axios.get(`${getApiBase()}/me/marketplace/balance`, {
    headers: authHeaders(),
  });
  return data;
}

/** @returns {{ balance: number, owned: string[], catalog: object[], equippedAvatarCosmeticId, equippedUsernameStyleId }} */
export async function fetchMarketplaceShop() {
  const { data } = await axios.get(`${getApiBase()}/me/marketplace/shop`, {
    headers: authHeaders(),
  });
  return data;
}

/** @returns {{ balance: number, owned: string[], itemId: string, price: number }} */
export async function purchaseMarketplaceItem(itemId) {
  const { data } = await axios.post(
    `${getApiBase()}/me/marketplace/purchase`,
    { itemId },
    { headers: authHeaders() }
  );
  return data;
}

/** @returns {{ transactions: object[], total: number, limit: number, offset: number }} */
export async function fetchMyMarketplaceTransactions({ limit = 50, offset = 0 } = {}) {
  const { data } = await axios.get(`${getApiBase()}/me/marketplace/transactions`, {
    headers: authHeaders(),
    params: { limit, offset },
  });
  return data;
}

/** @returns {{ transactions: object[], total: number, limit: number, offset: number }} */
export async function fetchAdminMarketplaceTransactions({ limit = 50, offset = 0, userEmail = "" } = {}) {
  const params = { limit, offset };
  const email = String(userEmail || "").trim();
  if (email) params.userEmail = email;
  const { data } = await axios.get(`${getApiBase()}/admin/marketplace/transactions`, {
    headers: authHeaders(),
    params,
  });
  return data;
}

/**
 * Admin: assign V-coins to a user with a short message.
 * @returns {{ ok: true, userId: number, userEmail: string, amount: number, balance: number, note: string, triggerId: string }}
 */
export async function grantAdminMarketplaceAward({ userEmail, userId, amount, note } = {}) {
  const body = {
    amount: Math.trunc(Number(amount) || 0),
    note: String(note || "").trim(),
  };
  const email = String(userEmail || "").trim().toLowerCase();
  if (email) body.userEmail = email;
  if (userId != null && Number.isFinite(Number(userId))) body.userId = Number(userId);
  const { data } = await axios.post(`${getApiBase()}/admin/marketplace/grant`, body, {
    headers: authHeaders(),
  });
  return data;
}
